import React from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethodSell = ({ navigation }) => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='paymentMethodSell.headerEscolheForma'/>} />

            <View style={styles.content}>
                <View style={styles.contentList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate({ name: "SearchUsers", params: { "page":"ConfirmSearchUserSell" } })}>
                        <Image style={[styles.iconInfo, { width: 28, height: 20 }]} source={require('../../../assets/imgs/search.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodSell.txtBuscar'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodSell.txtVendaTokensUsuarios'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("Exchange")}>
                        <Image style={[styles.iconInfo, { width: 25, height: 25 }]} source={require('../../../assets/imgs/exchange.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodSell.txtExchange'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodSell.txtNegocieTokensOrdensVenda'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("MarketplaceCategories")}>
                        <Image style={[styles.iconInfo, { width: 25, height: 25 }]} source={require('../../../assets/imgs/platform.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodSell.txtParaPlataforma'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodSell.txtVendaTokensMarketplace'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />
                </View>
            </View>
        </>
    );
}

export default PaymentMethodSell;